// extracted by mini-css-extract-plugin
module.exports = {"Canvas":"Settings_Canvas__2ZxbU","Settings":"Settings_Settings__3_3RK","Cam":"Settings_Cam__2CxXy"};